import { Chart, ChartXAxis, ChartXAxisItem, ChartSeries, ChartSeriesItem, ChartTitle } from "@progress/kendo-react-charts";
import { Fragment, useEffect, useState } from "react";
import SweetAlertService from "../../../services/SweetAlertService";
import ReportService from "../Services/ReportService";
import { AppConstants, setTargetErrorMessages } from "../Shared/Constants/AppConstant";

export const SetTarget = (props: any) => {
    const [targetedCategories, setTargetedCategories] = useState<any>([]);
    const [isAlreadySetTargetExists, setIsAlreadySetTargetExists] = useState<any>();
    const [weekRange, setWeekRange] = useState<any>([]);
    const [fieldErrors, setFieldErrors] = useState<any[]>([]);
    const [totalNumberOfWeeks, setTotalNumberOfWeeks] = useState<any>();

    useEffect(() => {
        getSetTargetDetails();
    }, []);

    const getSetTargetDetails = () => {
        let payload: any = {};
        payload.startDate = new Date(props.startDate.getFullYear(), props.startDate.getMonth(), props.startDate.getDate(), 0, 0, 0);
        payload.endDate = new Date(props.endDate.getFullYear(), props.endDate.getMonth(), props.endDate.getDate(), 23, 59, 59);
        payload.employerID = props.employerID;
        ReportService.getTargetDetails(payload).then((response: any) => {
            if (response) {
                setTargetedCategories(response.data.categoriesTargetDtos);
                let fieldErrors: any = [];
                response.data.categoriesTargetDtos.map((value: any, index: any) => {
                    fieldErrors.push({ categoryId: '', hours: '', minutes: '' });
                })
                setFieldErrors(fieldErrors);
                setIsAlreadySetTargetExists(response.data.isAlreadySetTargetExists);
                setWeekRange(response.data.xAxisRange);
                props.setTargetData((response.data.categoriesTargetDtos.filter((x: any) => x.categoryTargetsWeekDataDto.totalWorkedHours.length > 0)).length > 0);
                setTotalNumberOfWeeks(response.data.totalNumberOfWeeks);
            }
        })
            .catch((error: any) => {
                console.log(error);
                SweetAlertService.error("Error", "Something went wrong while loading set target chart");
            });
    }

    // To get color for line chart
    const getColorForLineChart = (item: any) => {
        let map: any = {
            1: '#0967B1',
            2: '#DA1F6C',
            3: '#008E82',
            4: '#6F4F9B',
            5: '#EA580D',
        };

        if (item.isUserDefined) {
            return '#76A227'
        } else {
            return map[item.categoryId];
        }
    }

    //To handle on changing the values
    const handleChange = (index: number, field: keyof any, value: number) => {
        setTargetedCategories((prevValues: any) => {
            const updatedValues = [...prevValues];
            if (!value.toString().startsWith('-') && (!value.toString().includes('.')) && !(field == 'minutes' && value > 59)) {
                updatedValues[index][field] = value;
            }
            return updatedValues;
        });
    };

    const handleBlur = (index: number, field: keyof any) => {
        const newFieldErrors = [...fieldErrors];

        //To check validation
        //Removing error message if category set to 0
        if (targetedCategories[index]["hours"] == 0 || targetedCategories[index]["minutes"] == 0) {
            newFieldErrors[index]["minutes"] = "";
        }
        //Checking if user not changed any category
        if (targetedCategories[index]["hours"] != 0 || targetedCategories[index]["minutes"] != 0) {
            if (field == "minutes") {
                if (targetedCategories[index]["hours"] == 0 && targetedCategories[index][field] < 10) {
                    newFieldErrors[index]["minutes"] = setTargetErrorMessages.lowHoursAndMinutes;
                }
                else if ((targetedCategories[index]["hours"] >= 48 && targetedCategories[index][field] > 0) || targetedCategories[index]["hours"] > 48) {
                    newFieldErrors[index]["minutes"] = setTargetErrorMessages.highHoursAndMinutes;
                } else {
                    newFieldErrors[index]["minutes"] = '';
                }
            } else {
                if (targetedCategories[index][field] == 0 && targetedCategories[index]["minutes"] < 10) {
                    newFieldErrors[index]["minutes"] = setTargetErrorMessages.lowHoursAndMinutes;
                }
                else if ((targetedCategories[index][field] >= 48 && targetedCategories[index]["minutes"] > 0) || targetedCategories[index]["hours"] > 48) {
                    newFieldErrors[index]["minutes"] = setTargetErrorMessages.highHoursAndMinutes;
                } else {
                    newFieldErrors[index]["minutes"] = '';
                }
            }
        }
        //To set errors 
        setFieldErrors(newFieldErrors);
    };

    //To handle form submit
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // Check for errors
        const newFieldErrors: any[] = [];
        targetedCategories.forEach((values: any, index: any) => {
            const rowErrors: any = {
                categoryId: '',
                hours: '',
                minutes: '',
            };
            //Checking if user not changed any category
            if (values.hours != 0 || values.minutes != 0) {
                if (values.hours == 0 && values.minutes < 10) {
                    rowErrors.minutes = setTargetErrorMessages.lowHoursAndMinutes;
                } else if ((values.hours >= 48 && values.minutes > 0) || values.hours > 48) {
                    rowErrors.minutes = setTargetErrorMessages.highHoursAndMinutes;
                }
            }
            newFieldErrors.push(rowErrors);
        });
        setFieldErrors(newFieldErrors);
        //Showing the error message if all the category set to 0
        if (targetedCategories.every((x: any) => x.hours == 0 && x.minutes == 0)) {
            SweetAlertService.error("Error", setTargetErrorMessages.lowHoursAndMinutes);
        } else if (newFieldErrors.every((errors) => !Object.values(errors).some((error) => error !== ''))) {
            let payload: any = {};
            payload.memberEmployerId = props.employerID;
            payload.categories = targetedCategories;
            ReportService.updateTargetDetails(payload).then((response: any) => {
                if (response) {
                    SweetAlertService.success("Success", AppConstants.successMessageForUpdatingSetTarget);
                    getSetTargetDetails();
                }
            })
                .catch((error: any) => {
                    console.log(error);
                    SweetAlertService.error("Error", "Something went wrong while updating the set targets");
                });
        }
    };

    return (
        <>
            {
                !props.showExportPdf && (
                    <div className="container-fluid m-0 p-0">
                        <div className="row">
                            <span className="text-muted fs-6 ms-0 p-0 ms-2 mt-1 mb-3">You can set additional targets for the categories of work in your diary.</span>
                        </div>
                        <div className="row">
                            <div className="card-body">
                                <form onSubmit={handleSubmit} >
                                    <div className="form-group">
                                        <div className="col-lg-12">
                                            {
                                                targetedCategories.length > 0 &&
                                                (
                                                    <div className="table-responsive-xl">
                                                        <table className="table justify-content-center mb-3 pb-3 customTableForSetTarget">
                                                            <thead className="table-info">
                                                                <tr>
                                                                    <th className="customHeader" scope="col"></th>
                                                                    <th className="text-center customHeader" scope="col">Time/Week</th>
                                                                    <th className="customHeader" scope="col"></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {targetedCategories.map((category: any, index: any) => (
                                                                    <Fragment key={index}>
                                                                        <tr>
                                                                            <td className="text-start" hidden>{category.categoryId}</td>
                                                                            <td className="text-start col-lg-9">{category.categoryName}</td>
                                                                            <td className="d-flex flex-row col-lg-8">
                                                                                <input type="number" className="form-control col-xs-6"
                                                                                    value={category.hours}
                                                                                    onChange={(e) => handleChange(index, 'hours', +e.target.value)}
                                                                                    onBlur={() => handleBlur(index, 'hours')}
                                                                                    onKeyDown={e => (e.key == "." || e.key == "-") && e.preventDefault()}
                                                                                />
                                                                                <label className="col-lg-10 mt-2">&nbsp;hrs </label>
                                                                                <input type="number" className="form-control col-xs-6"
                                                                                    value={category.minutes}
                                                                                    onChange={(e) => handleChange(index, 'minutes', +e.target.value)}
                                                                                    onBlur={() => handleBlur(index, 'minutes')}
                                                                                    onKeyDown={e => (e.key == "." || e.key == "-") && e.preventDefault()}
                                                                                />
                                                                                <label className="col-lg-10 mt-2">&nbsp;mins</label>
                                                                            </td>
                                                                        </tr>
                                                                        <tr className="text-start">
                                                                            {fieldErrors[index]?.minutes ? (
                                                                                <>
                                                                                    <td className="help-block m-b-none text-danger field-validation-valid">{fieldErrors[index].minutes}</td>
                                                                                </>
                                                                            ) : <></>}
                                                                        </tr>
                                                                    </Fragment>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                        <button className="btn btn-primary mb-3">{isAlreadySetTargetExists ? "Update" : "Submit"}</button>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                )
            }
            {
                props.showExportPdf
                && ((targetedCategories.filter((x: any) => x.categoryTargetsWeekDataDto.totalWorkedHours.length > 0)).length > 0)
                && (
                    <div className="container-fluid m-0 p-0">
                        <div className="row">
                            <span className="text-muted fs-6 ms-0 p-0 ms-2 mt-1 mb-3">You can set additional targets for the categories of work in your diary.</span>
                        </div>
                        <div className="row">
                            <div className="card-body">
                                <form onSubmit={handleSubmit} >
                                    <div className="form-group">
                                        <div className="col-lg-12">
                                            {
                                                targetedCategories.length > 0 &&
                                                (
                                                    <div className="table-responsive-xl">
                                                        <table className="table justify-content-center mb-3 pb-3 customTableForSetTarget">
                                                            <thead className="table-info">
                                                                <tr>
                                                                    <th className="customHeader" scope="col"></th>
                                                                    <th className="text-center customHeader" scope="col">Time/Week</th>
                                                                    <th className="customHeader" scope="col"></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {targetedCategories.filter((x: any) => x.categoryTargetsWeekDataDto.totalWorkedHours.length > 0).map((category: any, index: any) => (
                                                                    <Fragment key={index}>
                                                                        <tr>
                                                                            <td className="text-start" hidden>{category.categoryId}</td>
                                                                            <td className="text-start col-lg-9">{category.categoryName}</td>
                                                                            <td className="d-flex flex-row col-lg-8">
                                                                                <input type="number" className="form-control col-xs-6"
                                                                                    value={category.hours}
                                                                                    onChange={(e) => handleChange(index, 'hours', +e.target.value)}
                                                                                    onBlur={() => handleBlur(index, 'hours')}
                                                                                />
                                                                                <label className="col-lg-10 mt-2">&nbsp;hrs </label>
                                                                                <input type="number" className="form-control col-xs-6"
                                                                                    value={category.minutes}
                                                                                    onChange={(e) => handleChange(index, 'minutes', +e.target.value)}
                                                                                    onBlur={() => handleBlur(index, 'minutes')}
                                                                                />
                                                                                <label className="col-lg-10 mt-2">&nbsp;mins</label>
                                                                            </td>
                                                                        </tr>
                                                                        <tr className="text-start">
                                                                            {fieldErrors[index]?.minutes ? (
                                                                                <>
                                                                                    <span className="help-block m-b-none text-danger field-validation-valid">{fieldErrors[index].minutes}</span>
                                                                                </>
                                                                            ) : <></>}
                                                                        </tr>
                                                                    </Fragment>
                                                                ))
                                                                }
                                                            </tbody>
                                                        </table>
                                                        <button className="btn btn-primary mb-3">{isAlreadySetTargetExists ? "Update" : "Submit"}</button>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                )
            }
            {
                targetedCategories && targetedCategories.filter((x: any) => x.categoryTargetsWeekDataDto.totalWorkedHours.length > 0).map((category: any, index: any) => (
                    <Fragment key={index}>
                        <div className="fw-1 mt-5">{category.categoryName}</div>
                        <div className="Container-fluid mt-1">
                            <div className="row">
                                <div className="col-lg-12">
                                    <Chart transitions={false}>
                                        <ChartTitle text="Total hours worked" position="top" align="left" />
                                        <ChartXAxis>
                                            <ChartXAxisItem
                                                title={{ text: "Weeks", position: "bottom" }}
                                                categories={weekRange}
                                                max={(totalNumberOfWeeks >= 8) ? (weekRange[weekRange.length - 1] + 0.5) : weekRange[weekRange.length - 1]}
                                            />
                                        </ChartXAxis>
                                        <ChartSeries>
                                            <ChartSeriesItem width={2} color={getColorForLineChart(category)} type="scatterLine" data={category.categoryTargetsWeekDataDto.totalWorkedHours}
                                                dashType={(category.categoryId === 1 || category.categoryId === 4 || category.isUserDefined) ? 'dash' : 'solid'}
                                                markers={{
                                                    size: ((category.categoryId === 1) ? 24 :
                                                        (category.categoryId === 2 || category.categoryId === 4) ? 15 :
                                                            (category.categoryId === 5 || category.isUserDefined) ? 9 :
                                                                (category.categoryId === 3) ? 30 : 24),
                                                    type: ((category.categoryId === 1) ? 'circle' :
                                                        (category.categoryId === 2 || category.categoryId === 4) ? 'square' :
                                                            (category.categoryId === 5 || category.isUserDefined) ? 'triangle' :
                                                                (category.categoryId === 3) ? 'cross' : 'circle'),
                                                    background: "none",
                                                    visible : true
                                                }} />
                                            <ChartSeriesItem width={2} markers={{ size: 24, visible: (category.categoryTargetsWeekDataDto.totalWorkedHours.length == 1) ? true : false }} color="grey" type="scatterLine" data={category.categoryTargetsWeekDataDto.targetHours} />
                                        </ChartSeries>
                                    </Chart>
                                </div>
                            </div>
                        </div>
                    </Fragment>
                ))
            }
        </>
    )
}